
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disclaimer",
      function () {
        return require("private-next-pages/disclaimer/index.js");
      }
    ]);
  